import { useEffect } from "react";
import LoginForm from "./login.view";
import { AuthContainer } from "../security/auth/auth.container";
import { useNavigate } from "react-router";
import PATHS from "../../constants/paths";
import * as NavServices from "../../services/NavServices";

const LoginExtContainer = () => {
  const navigate = useNavigate();
  const auth = AuthContainer.useContainer();

  const handleSubmit = async (values) => {
    const result = await auth.login(
      values.user.toLocaleLowerCase(),
      values.password
    );
    if (result) {
      NavServices.cleanNavigation();
      navigate(PATHS.SETTING_PROFILE);
    }
  };

  return (
    <LoginForm
      onSubmit={handleSubmit}
      // logout={logout}
    ></LoginForm>
  );
};

export default LoginExtContainer;
